import React                            from 'react';
import { useDispatch, useSelector }     from 'react-redux';
import { Modal, Button, Form, Alert }   from 'react-bootstrap';

import { ICON_SAVE, ICON_CANCEL }       from '../../../../extras/icons';
import ButtonSpinner                    from '../../../../layout/ButtonSpinner';
import resortearJuezAction              from '../../../../../actions/resortearJuezAction';

import { ErrorMessage }                 from '../../../../extras/toastMessages';




const MotivoResorteoForm = props => {
    


    // ==========================================================================================
    // TOMO LOS PROPS ---------------------------------------------------------------------------
    // ==========================================================================================
    const { show, handleClose, idAudiencia, ResorteoDto } = props;
    
    

    // ==========================================================================================
    // DECLARACIONES ----------------------------------------------------------------------------
    // ==========================================================================================    
    const dispatch = useDispatch();
    

    
    // ==========================================================================================
    // CARGA DE VALORES -------------------------------------------------------------------------
    // ==========================================================================================
    const authorities = useSelector(state => state.auth.authorities);
    const motives = useSelector( state => state.audienceMotives.audienceMotives );    
    const usersLoading = useSelector( state => state.users.loadingSave );
    
    
    
    // ==========================================================================================
    // FUNCIONES --------------------------------------------------------------------------------
    // ==========================================================================================

    // Manejo de cambios
    const handleChange = e => {
        if(e.target.name==="observaciones")
        {   ResorteoDto.observaciones = e.target.value;   
        }
        else
        {   var sel = document.getElementById("motivo");
            ResorteoDto.motivo.id = e.target.value;
            ResorteoDto.motivo.descripcion = sel.options[sel.selectedIndex].text;
        }
    } 

    // Envia los datos al BE
    const resortear = async (e) => {
        e.preventDefault();
        if( ResorteoDto.motivo.id!=='' && ResorteoDto.motivo.descripcion!=='' )
        {   // Llamo al dispatch
            dispatch( resortearJuezAction(idAudiencia, ResorteoDto, handleClose) );
        }
        else
        {   ErrorMessage('Se requiere el Motivo');
        }
    }
       


    // ==========================================================================================
    // RENDERIZO --------------------------------------------------------------------------------
    // ========================================================================================== 
    return (
        <Modal 
            aria-labelledby = "contained-modal-title-vcenter" 
            centered
            onHide = { handleClose } 
            show = { show } 
            size = "md"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <strong>Resortear Juez</strong>
                </Modal.Title>
            </Modal.Header>
            <form onSubmit = { resortear }>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12">
                            <Alert variant="info">
                                Seleccione un motivo.
                            </Alert>
                        </div>
                    </div>
                    <div className="row">                                    
                        <Form.Group className="col-md-12">
                            <label htmlFor="motivo">Motivo</label>
                            <Form.Control
                                as = "select"
                                className = "form-control"
                                disabled = { usersLoading }
                                id = "motivo"  
                                name = "motivo" 
                                onChange = { handleChange }
                                type = "text"
                            >
                                <option value="">Seleccione el Motivo</option>
                                {   motives 
                                        ?
                                            motives.map( motivo=>(
                                                (motivo.grupoId===3) && (motivo.activo===1)
                                                    ?   
                                                        <option value={motivo.id} key={`ul${motivo.id}`}>
                                                            { motivo.descripcion }
                                                        </option>
                                                    :
                                                        null                                           
                                            ))
                                        : 
                                            null
                                }
                            </Form.Control>
                        </Form.Group>
                    </div>
                    <div className="row">                                    
                        <Form.Group className="col-md-12">
                            <label htmlFor="observaciones">Observaciones</label>
                            <Form.Control
                                as = "textarea"
                                className = "form-control"
                                disabled = { usersLoading }
                                id = "observaciones"
                                name = "observaciones"
                                onChange = { handleChange }
                                rows = { 3 }
                                type = "text"
                            >
                            </Form.Control>
                        </Form.Group>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {   usersLoading 
                            ?
                                <ButtonSpinner />
                            :
                                <Button variant="success" type="submit" disabled={ usersLoading }>
                                    <ICON_SAVE /> <strong>GUARDAR</strong>
                                </Button>
                    }
                    <Button variant="secondary" onClick={handleClose} disabled={ usersLoading }>
                        <ICON_CANCEL /> Cancelar
                    </Button>
                </Modal.Footer>
            </form>
        </Modal>
    );
};

export default MotivoResorteoForm;
